import React from 'react';

import CommentContainer from 'user/components/comments/commentContainer';
import { useAppContext } from 'hooks/useContext';
import { FreecodeTabContentContainer } from '../styles';
import { DiscussionContainer } from './styles';

export default function FreecodeDiscussion({ testId, contestId }) {
  const { isDarkMode } = useAppContext();

  return (
    <FreecodeTabContentContainer lightGradient={!isDarkMode} isDarkMode={isDarkMode}>
      <DiscussionContainer isDarkMode={isDarkMode}>
        <CommentContainer testId={testId} contestId={contestId} />
      </DiscussionContainer>
    </FreecodeTabContentContainer>
  );
}
